import { Component, OnInit, OnDestroy } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SharingDataService } from './../service/sharing-data.service';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';


@Component({
  selector: 'app-notifications-view',
  templateUrl: './notifications-view.component.html',
  styleUrls: ['./notifications-view.component.css']
})
export class NotificationsViewComponent implements OnInit {
  notificationId: number;
  notificationViewData: any = {};
  loading: any;
  //getNotificationSubscription: Subscription;
  private onDestroy$: Subject<void> = new Subject<void>();
  constructor(private serviceURLService: serviceURLService, private router: Router, private activatedRoute: ActivatedRoute, public sharingDataService: SharingDataService) {

  }

  ngOnInit() {
    this.activatedRoute.params.subscribe(paramsId => {
      this.notificationId = paramsId.notificationId;
    });
    this.getnotificationData();
    this.readNotification(this.notificationId); 
  }

  getnotificationData() {
    let data = {
      "updatedTime": null,
    }

    this.serviceURLService.newNotification(data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      for(const notification of successData.response.notifications) {
        if(notification._id === this.notificationId) {
          this.notificationViewData = notification;
        }
      }
    }, errorData => {
    })
  };

  readNotification(notificationId) {
    const notificationData = {
      '_id': notificationId
    }
    this.serviceURLService.viewNotification(notificationData).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {

    }, errorData => {

    })
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }

}
